import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const getDuration = (start: Date, stop: Date | dayjs.Dayjs): duration.Duration => {
  const djStart = dayjs(start);
  const djStop = dayjs(stop);

  return dayjs.duration(djStop.diff(djStart));
};
